import { render, staticRenderFns } from "./productInformation.vue?vue&type=template&id=268b57de&scoped=true&"
import script from "./productInformation.vue?vue&type=script&lang=js&"
export * from "./productInformation.vue?vue&type=script&lang=js&"
import style0 from "./productInformation.vue?vue&type=style&index=0&id=268b57de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b57de",
  null
  
)

export default component.exports